import { render, staticRenderFns } from "./OptInModal.vue?vue&type=template&id=23738340&scoped=true"
import script from "./OptInModal.vue?vue&type=script&lang=js"
export * from "./OptInModal.vue?vue&type=script&lang=js"
import style0 from "./OptInModal.vue?vue&type=style&index=0&id=23738340&prod&lang=scss&scoped=true"
import style1 from "./OptInModal.vue?vue&type=style&index=1&id=23738340&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23738340",
  null
  
)

export default component.exports